<template>
  <div>
    <div class="content-header">
      <div class="left" style="align-items: unset">
        <span class="title">智能运维安全码</span>
      </div>
    </div>
    <div class="tips" style="margin-bottom: 20px">
      <Icon
        type="md-alert"
        size="20"
        color="#2d8cf0"
        style="margin-right: 10px"
      />
      <div>
        <div>本页安全码仅包含智能运维的安全码，在应用中心中购买成功后，系统将自动分发所购数量的安全码至此页面；
        </div>
      </div>
    </div>
    <div>
      <Table :data="data" :columns="columns" />
      <div class="t-right"  style="margin-top:10px;">
        <Page
          @on-change="pageChange"
          @on-page-size-change="sizeChange"
          :total="total"
          show-elevator
          show-sizer
          show-total
        />
      </div>
    </div>
    <Modal width="320" v-model="modal.visible" title="生成激活码">
      <Alert type="warning">无需考虑大小写</Alert>
      <Input v-model="modal.data.sn" placeholder="输入设备序列号" />
      <div slot="footer">
        <Button @click="modal.visible = false">取消</Button>
        <Button @click="makeActivation" type="primary">确定</Button>
      </div>
    </Modal>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
export default {
  data () {
    return {
      data: [],
      page: {
        p: 0,
        l: 10
      },
      total: 0,
      columns: [
        {
          key: 'code',
          title: '安全码',
          width: 200,
          render: (h, data) => {
            return h(
              'span',
              {},
              data.row.code ? data.row.code : '****************'
            )
          }
        },
        {
          key: 'status',
          title: '状态',
          width: 100,
          render: (h, data) => {
            return h(
              'span',
              {
                style: { color: data.row.status === 2 ? '#ed4014' : '#19be6b' }
              },
              data.row.status === 2 ? '已激活' : '未激活'
            )
          }
        },

        {
          key: 'type',
          title: '类型',
          width: 120,
          render: (h, data) => {
            // 0云知印1抄表2激活
            let type = {
              0: '云知印',
              1: '智能运维',
              2: '激活码'
            }
            return h('span', {}, type[data.row.type])
          }
        },
        { key: 'month', width: 100, title: '所含运营期' },
        { key: 'name', width: 120, title: '仓库' },

        {
          key: 'create_time',
          title: '购买时间',
          width: 170,
          render: (h, data) => {
            return h('span', {}, this.$moment(data.row.create_time))
          }
        },
        {
          key: 'sn',
          title: '设备序列号',
          width: 170,
          render: (h, data) => {
            return h('span', {}, data.row.sn ? data.row.sn : '-')
          }
        },
        {
          key: 'bind_time',
          title: '激活时间',
          width: 170,
          render: (h, data) => {
            return h(
              'span',
              {},
              data.row.bind_time ? this.$moment(data.row.bind_time) : '-'
            )
          }
        },
        {
          key: 'invalid_time',
          title: '有效截止时间',
          width: 170,
          render: (h, data) => {
            return h(
              'span',
              {},
              data.row.invalid_time &&
                (data.row.status === 1 || data.row.status === 3)
                ? this.$moment(data.row.invalid_time)
                : '-'
            )
          }
        }
        /* {key: "operate",title: "操作",render:(h,data)=>{
          if(data.row.type === 2 && !data.row.code){
            return h("Button",{
              props: {type: "primary",size: "small"},
              on: {click:()=>{
                this.modal = {
                  visible: true,
                  data: {
                    sn: "",
                    id: data.row.id
                  },
                }
              }}
            },"生成激活码")
          }
        }}, */
      ],
      modal: {
        visible: false,
        data: {
          sn: '',
          id: 0
        }
      }
    }
  },
  mounted () {
    if (this.user.tp === 0) {
      this.columns.push({
        key: 'agent_name',
        title: '合作伙伴',
        width: 300,
        render: (h, data) => {
          return h('span', {}, data.row.agent_name ? data.row.agent_name : '-')
        }
      })
    }
    this.getData()
  },
  methods: {
    makeActivation () {
      this.MakeActivation({
        sn: this.modal.data.sn,
        id: this.modal.data.id
      }).then((res) => {
        if (res) {
          this.modal.visible = false
          this.getData()
        }
      })
    },
    getData () {
      this.GetAgentOperateCode(this.page).then((res) => {
        this.data = res.data
        this.total = res.total
      })
    },
    sizeChange (l) {
      this.page.l = l
      this.getData()
    },
    pageChange (p) {
      this.page.p = p - 1
      this.getData()
    },
    ...mapActions(['GetAgentOperateCode', 'MakeActivation'])
  },
  computed: mapGetters({
    user: 'agent'
  }),
  watch: {}
}
</script>
<style lang='less'>
@import "./index.less";
.tips {
  background: #eaf7fd;
  color: #4a5163;
  border-radius: 4px;
  padding: 8px 6px;
  font-size: 12px;
  display: flex;
  align-items: center;
}
</style>
